import React, { FCC } from 'react';
import { IBackgroundImageProps } from './types';

export const BackgroundImage: FCC<IBackgroundImageProps> = (props) => {
  const {
    src,
    backgroundColor = 'transparent',
    backgroundPosition = '50% 50%',
    backgroundSize = 'contain',
    backgroundRepeat = 'no-repeat',
    height,
    width,
  } = props;

  return (
    <div
      qa-id={props['qa-id']}
      style={{
        backgroundColor,
        backgroundImage: 'url("' + src + '")',
        backgroundPosition,
        backgroundRepeat,
        backgroundSize,
        height,
        width,
      }}
    >
      <span role="image" aria-label={props.alt} />
      {props.children}
    </div>
  );
};

export default BackgroundImage;
